import ViewModel from '@/ViewModels/ViewModel';
import type ViewFactory from '@/Factories/ViewFactory';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';
import BusyCounter from '@/Utility/BusyCounter';

export default class ViewViewModel extends ViewModel {

    /**
     * Die erzeugende ViewFactory
     */
    public viewFactory: ViewFactory;

    /**
     * Gibt an, ob die View geladen wird
     */
    public isBusy: KnockoutObservable<boolean>;
    private busyCounter: BusyCounter;
    
    public constructor(params: CoreFrameInterfaces.IViewViewModelConstructorParameter) {
        super(params);

        this.viewFactory = this.paramOrDefault(params.viewFactory, null);
        this.isBusy = this.observableOrDefault(params.isBusy, false);
        this.isDisposable = this.paramOrDefault(true);
    }

    public increaseBusyCounter(): void {
        if (this.isDisposed)
            return;

        if (!this.busyCounter)
            this.busyCounter = new BusyCounter(this.isBusy);

        this.busyCounter.increment();
    }

    public decreaseBusyCounter(): void {
        if (this.isDisposed || !this.busyCounter)
            return;

        this.busyCounter.decrement();
    }
}